import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import TrendLabel from './TrendLabel';
import styles from './TrendTimeline.styles';

export const partitionIntoOverlappingGroups = items => {
  const sorted = _.sortBy(items, 'start');
  const sortedEnds = _.sortBy(items, 'end');
  const starts = _.map(sorted, 'start');
  const ends = _.map(sortedEnds, 'end');
  
  let currentOverlap = 0;
  let maxGroupOverlap = 0;
  let currentGroup = [];
  let groups = [];
  let startsIndex = 0;
  let endsIndex = 0;
  const startsSize = _.size(starts);
  const endsSize = _.size(ends);
  const overlapIndexes = [];
  while (startsIndex < startsSize && endsIndex < endsSize) {
    if (starts[startsIndex] <= ends[endsIndex]) {
      currentOverlap++;
      maxGroupOverlap = Math.max(maxGroupOverlap, currentOverlap);
      const overlapIndex = _.find(_.range(0, 100), i => !overlapIndexes[i]);
      overlapIndexes[overlapIndex] = sorted[startsIndex];
      currentGroup.push({
        index: startsIndex,
        overlapIndex 
      });
      startsIndex++;
    } else {
      overlapIndexes[_.findIndex(overlapIndexes, sortedEnds[endsIndex])] = undefined;
      currentOverlap--;
      endsIndex++;
    };

    if (currentOverlap === 0 || startsIndex >= startsSize || endsIndex >= endsSize) {
      groups.push({
        items: _.map(currentGroup, ({ index, overlapIndex }) => ({
          item: sorted[index],
          overlapIndex 
        })),
        overlap: maxGroupOverlap 
      });
      currentGroup = [];
      maxGroupOverlap = 0;
    };
  };

  return groups;
};

const Timeline = ({
  items,
  allTrendTypes,
  height,
  onClickTrend
}) => {
  const overlappingGroups = partitionIntoOverlappingGroups(items);
  const maxOverlap = _.chain(overlappingGroups)
    .maxBy(group => group.overlap)
    .get('overlap')
    .value() || 1;
  return (
    <div
      style={styles.timeline(height)}>
      {_.flatMap(overlappingGroups, ({ items, overlap }) => _.map(items, ({ item, overlapIndex }) => (
        <TrendLabel
          key={item.trend.id}
          trend={item.trend}
          allTrendTypes={allTrendTypes}
          start={item.start}
          highlighted={item.highlighted}
          end={item.end}
          overlap={maxOverlap}
          overlapIndex={overlapIndex}
          height={height}
          onClickTrend={onClickTrend} />
      )))}
    </div>
  );
};

Timeline.propTypes = {
  items: PropTypes.array,
  percentageToTime: PropTypes.func.isRequired,
  onClickTrend: PropTypes.func
};

Timeline.displayName = 'Timeline';

export default Timeline;